import React from "react";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router";
import { t } from "ttag";

import { ErrorBox } from "merchant-portal-common/MessageBox";
import { routes } from "merchant-portal-pages/routes";

export const PermissionDenied = () => {
	const navigate = useNavigate();

	return (
		<Box
			sx={{
				width: "100%",
				height: "80vh",
				display: "flex",
				justifyContent: "center",
			}}
		>
			<ErrorBox
				testId="permission-denied"
				title={t`Permission Denied`}
				handleRetry={() => navigate(routes.transactions)}
				message={
					<Box>{t`You do not have permissions to view this page. If you think this is incorrect, please contact the Merchant Success team.`}</Box>
				}
				retryMessage={t`Return to home page`}
			/>
		</Box>
	);
};

export default PermissionDenied;
